module.exports = __webpack_public_path__ + "media/images/en/upload-newsletter-2ee572188e3aa12c1c5ae9975bab0bf1.png";